import { memo, PropsWithChildren, useEffect, useState } from 'react'
import { INode } from '../../../definitions/Nodes'
import EventsEngine from '../../../engines/EventsEngine'
import { FlowAnimationType } from '../../../definitions/FlowAnimation'

interface P {
    node: INode
    animation?: FlowAnimationType
    classes?: string
}

const BaseNodeUI = ({ node, animation, children }: PropsWithChildren<P>) => {
    const [compileStyle, setCompileStyle] = useState(false)
    const cssClass = (() => {
        switch (node.type) {
            case 'start': return 'start-node'
            case 'xfrm_sql': return 'xfrm-sql-node'
        }
    })()

    useEffect(() => {
        EventsEngine.subscribe('compile-error-style', 'BaseNodeUI' + node.uuid, (args: { hasErrors: boolean, nodeIds: string[] }) => {
            if (args.hasErrors && args.nodeIds?.includes(node.uuid))
                setCompileStyle(true)
            else
                setCompileStyle(false)
        })

        return () => {
            EventsEngine.unsubscribe('compile-error-style', 'BaseNodeUI' + node.uuid)
        }
    }, [node.uuid])

    const border = animation === 'executing' ? 'none' : animation === 'completed' ? '1px solid var(--color-okay)' : (animation === 'failed' || compileStyle) ? '1px solid var(--color-bad)' : undefined

    return (
        <div
            className={`react-flow__node-default custom-node-base selectable draggable ${cssClass}`}
            style={{ border }}
            onDoubleClick={() => EventsEngine.publish('on-node-doubleclick', { uuid: node.uuid })}>
            <div className={animation === 'executing' ? 'wrapper gradient' : ''}>
                <div style={{ overflow: 'hidden' }} className={animation === 'executing' ? 'inner' : ''}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default memo(BaseNodeUI)
